import Helper from '@ember/component/helper';

import { service } from '@ember/service';

export default class FieldHeightOverlaysHelper extends Helper {
  @service fieldHeightOverlays;

  compute() {
    return this.fieldHeightOverlays.containerEl;
  }
}
